import React, { useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
// import { resetpassword } from "../../actions/loginAction";
import { resetpassword } from "../../reducers/forgotPassword";
import {
  useNavigate,
  useLocation,
  useParams,
  Navigate,
} from "react-router-dom";
import { resetPassword } from "../../services/AuthServices";
import Alert from "../../components/common/alert";
import "../../components/basic/login/login.css";

const ResetPassword = () => {
  const { Title } = Typography;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const auth = useSelector((state) => state.auth);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const userId = new URLSearchParams(location.search).get("userId");

  const handleClick = () => {
    navigate("/register");
  };

  const handleLoginClick = () => {
    navigate("/");
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const response = await resetPassword({
        password: values.password,
        code: params.id,
        userId,
      });

      if (response.data.success) {
        dispatch(resetpassword(response.data.user));
        Alert("success", "Success!", response.data.message);
        setIsLoggedIn(true);
      } else {
        Alert(
          "error",
          "Error!",
          response.data.message.replaceAll("TRAINER", "TEACHER")
        );
      }
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      Alert("error", "Error!", message);
    }
  };

  if (isLoggedIn && auth?.userOptions?.[0]?.link) {
    return <Navigate to={auth.userOptions[0].link} replace />;
  }

  return (
    <div className="home-page-container">
      <div className="parallax">
        <div className="login-container">
          <div className="login-student-inner">
            <div className="space-btw">
              <Button className="login-btn" ghost onClick={handleLoginClick}>
                Sign In
              </Button>
              <Button className="register-btn" ghost onClick={handleClick}>
                Register
              </Button>
            </div>

            <div className="login-log">
              <img
                src="/assets/leagueonlinelogo2.png"
                alt="logo"
                width={"30%"}
              />
            </div>

            <Form form={form} onFinish={handleSubmit} layout="vertical">
              <div
                style={{ display: "flex", gap: 12, flexDirection: "column" }}
              >
                <div>
                  <Title
                    style={{
                      color: "white",
                      fontSize: "30px",
                      fontWeight: 400,
                    }}
                    level={4}
                  >
                    Reset your password?
                  </Title>
                  <Title
                    style={{
                      color: "white",
                      fontSize: "20px",
                      fontWeight: 400,
                      textAlign: "start",
                    }}
                  >
                    Please enter your new password
                  </Title>
                </div>

                <div
                  style={{ display: "flex", gap: 24, flexDirection: "column" }}
                >
                  <Form.Item
                    name="password"
                    label={
                      <span style={{ color: "white" }}>Enter New Password</span>
                    }
                    colon={false}
                    hasFeedback
                    rules={[
                      {
                        required: true,
                        message: "Please input new password!",
                      },
                    ]}
                  >
                    <Input.Password placeholder="Password" />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                      Reset Password
                    </Button>
                  </Form.Item>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
